<mat-dialog-content class="custom__class-dialog">
  <img width="48px" height="48px" src="assets/images/icons/warning-modal.png" alt="icon success modal">
  <h1>{{'modalConfirmation.titleWarning' | translate}}</h1>
</mat-dialog-content>
<mat-dialog-actions>
  <button class="custom__class-btn-modal-info btn btn-info" mat-dialog-close cdkFocusInitial
    [mat-dialog-close]="true">{{'modalConfirmation.button.continue' | translate}}</button>
  <button class="custom__class-btn-modal btn" mat-dialog-close
    [mat-dialog-close]="false">{{'modalConfirmation.button.yesCancel' | translate}}</button>
</mat-dialog-actions>